module.exports = __webpack_public_path__ + "static/media/StraightArrow.668e5cfd.svg";